import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import { FormikProps } from 'formik';
import * as React from 'react';
import { TranquiTheme } from '../../containers/App/theme';
import useDictionary from '../../dictionaries/context/useDictionary';
import RenderText from '../../dictionaries/RenderText';
import { NegotiationOption, NegotiationOptionAlternative, OutDebt } from '../../generated/graphql';
import FormikCheck from '../FormikInputWrappers/FormikCheck';
import FormikFormattedTextField from '../FormikInputWrappers/FormikFormattedTextField';
import AlertBase from './AlertBase';

interface ConditionsAgreementProps {
  negotiation?: NegotiationOption;
  alternative?: NegotiationOptionAlternative;
  formik?: FormikProps<any>;
  outDebt?: OutDebt;
}

const ConditionsAgreement: React.FC<ConditionsAgreementProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { gT } = useDictionary();
  const { outDebt, negotiation, formik, alternative } = props;

  if (!outDebt?.productNumber || !negotiation || !alternative) return null;
  return (
    <AlertBase
      type="informative"
      className={cn(classes.root, 'mb-2')}
      dataTest="cy-ConditionsAgreement-restriction"
      title="Condiciones de negociación"
    >
      {!!formik
        && (
          <Box className={classes.fieldContainer}>
            <FormikCheck
              className="mb-n1"
              formik={formik}
              valueId="newTermCheck"
              iconClassName={classes.iconCheckBox}
              helperTextClassName="mb-2"
              labelCheck={(
                <RenderText
                  isMarkdown
                  textKey="negotiation_InstallmentsPlan_newTermCheck"
                  context={{ term: alternative.term, productNumber: outDebt.productNumber }}
                />
              )}
            />
            <FormikCheck
              className="mb-n1"
              formik={formik}
              valueId="newTermRateCheck"
              iconClassName={classes.iconCheckBox}
              helperTextClassName="mb-2"
              labelCheck={(
                <RenderText
                  isMarkdown
                  textKey="negotiation_InstallmentsPlan_newTermRateCheck"
                  context={{ term: alternative.term, productNumber: outDebt.productNumber }}
                />
              )}
            />
            <FormikCheck
              className="mb-n1"
              formik={formik}
              valueId="originalMonthlyRateCheck"
              iconClassName={classes.iconCheckBox}
              helperTextClassName="mb-2"
              labelCheck={(
                <RenderText
                  isMarkdown
                  textKey="negotiation_InstallmentsPlan_originalMonthlyRateCheck"
                  context={{ term: alternative.term, productNumber: outDebt.productNumber }}
                />
              )}
            />
            <FormikCheck
              className="mb-2"
              formik={formik}
              valueId="restructuredCheck"
              iconClassName={classes.iconCheckBox}
              helperTextClassName="mb-2"
              labelCheck={(
                <RenderText
                  isMarkdown
                  textKey="negotiation_InstallmentsPlan_restructuredCheck"
                  context={{ term: alternative.term, productNumber: outDebt.productNumber }}
                />
              )}
            />
            <Typography>
              <RenderText
                isMarkdown
                textKey="negotiation_InstallmentsPlan_ageCheck_description"
              />
            </Typography>

            <FormikFormattedTextField
              className={`mt-1 ${classes.fieldContainer} ${classes.ageFieldContainer}`}
              valueId="age"
              formik={formik}
              placeholder={gT('negotiation_InstallmentsPlan_ageCheck')}
              disableAutoComplete
              format={{ format: '##' }}
            />
          </Box>
        )}
    </AlertBase>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {},
  checkBox: {
    padding: theme.spacing(-1, 0),
  },
  checkBoxText: {
    ...theme.typography.body2,
  },
  iconCheckBox: {
    width: '0.8em',
    height: '0.8em',
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  ageFieldContainer: {
    flexDirection: 'column-reverse',
  },
}));

export default ConditionsAgreement;
